import React, { useState } from 'react';

import { FeedbackFormProps } from './types';
import ActionButton from '../../../components/ActionButton/ActionButton';
import { ControlGroup, FeedbackTextField, FlexDiv, Label } from './styles';
import Loader from '../../../components/Loader/Loader';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { useTranslationContext } from '../../../../context/TranslationContext';

const FeedbackForm: React.FC<FeedbackFormProps> = ({ onDiscard, onSubmit }) => {
  const { t } = useI18n();
  const { isTranslationMode } = useTranslationContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState<string>('');

  const isSendDisabled = !message.trim();

  const handleSend = () => {
    setIsSubmitting(true);
    onSubmit(message).then(
      () => {
        setIsSubmitting(false);
      },
      () => {
        setIsSubmitting(false);
      }
    );
  };

  return (
    <>
      <ControlGroup>
        <Label>{t(TranslationKeys.feedbackForm_label_description)}</Label>
        {isTranslationMode ? (
          <div
            style={{
              border: '1px solid #d3d3d3',
              padding: '12px',
              borderRadius: '4px',
              color: '#495057',
              minHeight: '80px',
            }}
          >
            {t(TranslationKeys.feedbackForm_placeholder_description)}
          </div>
        ) : (
          <FeedbackTextField
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            variant="outlined"
            fullWidth
            placeholder={
              t(TranslationKeys.feedbackForm_placeholder_description) as string
            }
          />
        )}
      </ControlGroup>

      <FlexDiv style={{ flexDirection: isTranslationMode ? 'column' : 'row' }}>
        {isTranslationMode ? (
          <>
            <ActionButton
              variant="ghost"
              onClickAction={onDiscard}
              fullWidth={true}
              buttonText={t(TranslationKeys.feedbackForm_cancelButton)}
            />
            <br />
            <br />
            <ActionButton
              fullWidth={true}
              variant="accept-blue"
              buttonText={t(TranslationKeys.feedbackForm_submitButton)}
            />
          </>
        ) : (
          <>
            <ActionButton
              variant="ghost"
              onClickAction={onDiscard}
              buttonText={t(TranslationKeys.feedbackForm_cancelButton)}
            />
            {isSubmitting ? (
              <Loader />
            ) : (
              <ActionButton
                variant="accept-blue"
                disabled={isSendDisabled}
                onClickAction={handleSend}
                buttonText={t(TranslationKeys.feedbackForm_submitButton)}
              />
            )}
          </>
        )}
      </FlexDiv>
    </>
  );
};

export default FeedbackForm;
